class ClustersController
  @updateOptionsForConfiguration: (url) ->
    selectors =
      mainboard: "#mainboard"
      old_mainboard: "#old_mainboard"
      power_source_a: "#power_source_a"
      power_source_b: "#power_source_b"

    UiNodePowerConfigurationsController.updateOptionsForConfiguration(url, selectors)

$(document).ready ->
  $(document).on('change', '.clusters select[name=mainboard]', (event) ->
    ClustersController.updateOptionsForConfiguration($(this).data('url'))
  )
  $(document).on('change', '.clusters select[name=power_source_a]', (event) ->
    ClustersController.updateOptionsForConfiguration($(this).data('url'))
  )

module.exports = ClustersController
